import { render, staticRenderFns } from "./SalesNoteCreateUpdate.vue?vue&type=template&id=08abaa2b&scoped=true&"
import script from "./SalesNoteCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./SalesNoteCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./SalesNoteCreateUpdate.vue?vue&type=style&index=0&id=08abaa2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08abaa2b",
  null
  
)

export default component.exports